export default "__VITE_ASSET__BLGSA_$f__"